import React from 'react';
import { CircularProgress, Stack } from '@mui/material';

type LoadingFormProps = {};

export const LoadingForm: React.FC<LoadingFormProps> = () => {
  return (
    <Stack alignItems="center" justifyContent="center" height="30vh">
      <CircularProgress />
    </Stack>
  );
};
